import im from "../models/ic";

export const types = {
  IC_DATA: "IC_DATA",
  IC_DATA_SUCCESS: "IC_DATA_SUCCESS",
  IC_DATA_FAILED: "IC_DATA_FAILED",
};

export const actions = {
  icDataGet: (payload) => {
    return { type: types.IC_DATA, value: payload };
  },
};

const reducer = (state = im, action) => {
  switch (action.type) {
    case types.IC_DATA:
      return {
        ...state,
        loading: true,
      }
    case types.IC_DATA_SUCCESS:
      const { data = {} } = state;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: Object.assign(data, action.value)
      }
    case types.IC_DATA_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    default:
      return state;
  }
}

export default reducer;
